//
// React
//
import React from 'react';

// Create a context for the reducer bound to that components tree
const TenantContext = React.createContext(undefined);

export default TenantContext;
